<template>
  <v-navigation-drawer
    color="primary"
    v-model="drawer"
    app
    clipped
    left
    style="top: 64px; max-height: calc(100% - 64px)"
  >
    <v-list dense dark v-if="!loading">
      <v-list-item-group v-model="model" mandatory color="indigo">
        <router-link
          v-for="(menu, index) in menus"
          :key="index"
          class="white--text navigation-a-underline--remove"
          :to="menu.route"
          v-show="menu.visible"
          :data-cy="`accountBar_${menu.id}`"
        >
          <v-list-item
            link
            :disabled="menu.disabled"
            :data-cy="`accountBar_${menu.id}_list`"
          >
            <v-list-item-action>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ menu.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list-item-group>
    </v-list>
    <template v-slot:append>
      <powered-by-sentinel :is-navbar="true" />
    </template>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { USER_CRM_REQUEST } from "@/store/actions/user";
import restrictions from "@/utils/restrictions";
import PoweredBySentinel from "../banners/PoweredBySentinel.vue";

export default {
  components: { PoweredBySentinel },
  data: () => ({
    drawer: null,
    loading: true,
    drawerStatus: ["/account/", "/account/legal", "/account/billings"],
    model: null,
  }),
  created() {
    if (Object.keys(this.getMe).length === 0) {
      this.$store.dispatch(USER_CRM_REQUEST).then(() => {
        this.loading = false;
      });
    } else {
      this.loading = false;
    }

    this.drawerStatus.forEach((element, index) => {
      if (this.subMenuActive(element)) {
        this.model = index;
      }
    });
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "COLLAPSED") {
        this.drawer = mutation.payload;
      }
    });
  },

  watch: {
    getMe(newValue) {
      if (
        typeof newValue === "undefined" ||
        Object.keys(newValue).length === 0
      ) {
        return;
      }
    },
    drawer(val) {
      if (this.getDrawerStatus !== this.drawer) {
        this.$store.commit("COLLAPSED", val);
      }
    },
  },
  computed: {
    ...mapGetters([
      "getDrawerStatus",
      "getMe",
      "getIsLicenceStatusNeeded",
      "getIsUIDisabledBasedOnLicenceStatus",
    ]),
    menus() {
      return [
        {
          id: "partners",
          title: this.$t("components.navigationBar.accountBar.partners"),
          icon: "mdi-handshake",
          route: { name: "partners", query: { my_account: "true" } },
          visible: this.getMe.dealerships.length !== 0,
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
        {
          id: "legal",
          title: this.$t("components.navigationBar.accountBar.legal"),
          icon: "mdi-scale-balance",
          route: { name: "legal" },
          visible: true,
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
      ];
    },
  },
  methods: {
    subMenuActive(input) {
      return [input].some((path) => {
        return this.$route.path.indexOf(path) === 0;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
.navigation-text-size--hover {
  font-size: 14px;
  &:hover {
    color: --primary;
  }
}
.navigation-icon--hover {
  &:hover {
    color: --primary;
  }
}
.navigation-a-underline--remove {
  text-decoration: none;
}
</style>
